import { EStatEventType, EAppId } from '../../../../enums';
import { IStatParams } from '../../../../interfaces';
import { StatInstanceBase } from '../../StatInstanceBase';

import {
	IStatSubscriptionsComboLinkNavigationParams,
	IStatSubscriptionsPurchaseOfferParams,
	IStatSubscriptionsPurchasePhoneParams,
	IStatSubscriptionsPurchaseSmsParams,
	IStatSubscriptionsPurchaseCancelParams,
	IStatSubscriptionsSubscribeSuccessParams,
} from './types';

export class StatSubscriptionsApi extends StatInstanceBase {

	async sendStat(params: IStatParams) {
		return super.sendStat({
			appId: EAppId.WEB_VIEW,
			...params,
		});
	}

	comboLinkNavigation({ from }: IStatSubscriptionsComboLinkNavigationParams) {
		void this.sendStat({
			action: EStatEventType.WEBVIEW_COMBO_LINK,

			data0: from,
		});
	}

	purchaseOffer({ from, paymentOptions }: IStatSubscriptionsPurchaseOfferParams) {
		void this.sendStat({
			action: EStatEventType.PURCHASE_OFFER,

			data0: from,
			data1: paymentOptions,
		});
	}

	purchasePhone({ from, paymentOptions, result }: IStatSubscriptionsPurchasePhoneParams) {
		void this.sendStat({
			action: EStatEventType.PURCHASE_PHONE,

			data0: from,
			data1: paymentOptions,
			data2: result,
		});
	}

	purchaseSms({ from, paymentOptions, result }: IStatSubscriptionsPurchaseSmsParams) {
		void this.sendStat({
			action: EStatEventType.PURCHASE_SMS,

			data0: from,
			data1: paymentOptions,
			data2: result,
		});
	}

	purchaseCancel({ page, isTrialAvailable, paymentOptions }: IStatSubscriptionsPurchaseCancelParams) {
		void this.sendStat({
			action: EStatEventType.PURCHASE_CANCEL,

			data0: page,
			data1: isTrialAvailable,
			data2: paymentOptions,
		});
	}

	subscribeSuccess({ from, paymentOptions, isTrial }: IStatSubscriptionsSubscribeSuccessParams) {
		void this.sendStat({
			action: EStatEventType.SUBSCRIBE_SUCCESS,

			data0: from,
			data1: paymentOptions,
			data2: isTrial,
		});
	}

}
